<template>
   <div class="tree-contain">
      <div class="tree-scroll">
         <ul class="treeitems">
            <div v-if="treeitem=={}">No Data</div>
            <tree-item 
                  v-else 
                  :treeitem="treeitem" 
                  :selected="selected" 
                  :pageSize="pageSize"
                  :handle-click="handleClick"
                  :handle-link="handleLink"
                  :handle-fetch="handleFetch"
                  :enableAppointLink="enableAppointLink"
            ></tree-item>
         </ul>
      </div>
   </div>
</template>

<script>
import TreeItem from './tree-item.vue'


export default {
    name: 'tree',
    props: { 
        'treeitem': Object, 
        'selected': Object,
        'pageSize': Number,
        'enableAppointLink': Boolean
    },
    data() {
        return {

        }
    },
    components: {
    "tree-item": TreeItem,
    },
    mounted() {
        
    },
    methods: {
        handleClick (node) {
            this.$emit('node-click', node)
        },
        handleFetch (node) {
            this.$emit('more-click', node)
        },
        handleLink (node) {
            this.$emit('link-click',node)
        }
    }
}
</script>

<style lang="scss">
ul.treeitems {
    padding: 0 0rem;
    margin: 0;
    box-sizing: border-box;
    width: 100%;
    list-style: none;
    border: none;
    font-size: small;
}
.tree-scroll {
   padding: 4px 0;
   overflow-x: hidden;
   overflow-x: auto;
   min-height: 150px;
   max-height: 600px;
}

</style>